import React, { memo } from 'react';
import ms from 'ms';
import { routes } from 'constants/config';
import LoadableState from 'components/shared/loadable';
import Chart from 'components/Chart';
import colors from 'constants/colors';
import FilteredRequest from '../_shared/FilteredRequest';

const tickPositioner = () => [0, 100];

const SatisfactionChart = memo(({ i18n }) => (
  <FilteredRequest
    url={routes.INSIGHTS.RATINGS.SATISFACTION_OVER_TIME}
    include={{
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }}
  >
    {({ data, loading, params }) => (
      <LoadableState loading={loading}>
        {!data && i18n.loading}
        {data && (
          <Chart
            config={{
              chart: {
                type: 'area',
                height: '25%',
              },
              legend: {
                enabled: false,
              },
              xAxis: {
                type: 'datetime',
                tickInterval: ms('30 days'),
                dateTimeLabelFormats: {
                  month: '%b 1',
                },
                // Make the data fill the entire axis
                minPadding: 0,
                maxPadding: 0,
              },
              yAxis: {
                // Since we’re displaying a percentage, force ticks at 0% and 100%
                tickPositioner,
                // ...but set the max to 105% so the 4px-wide line isn’t cut off
                max: 105,
                endOnTick: false,
                labels: {
                  format: '{value}%',
                },
              },
              series: [
                // I would like to avoid manually parsing the dates to the JS
                // timestamps Highcharts expects, but can’t figure out how.
                {
                  name: i18n.ratings.positive_percent,
                  data: data.satisfaction.map(point => [
                    Date.parse(point[0]),
                    point[1],
                  ]),
                  color: colors.YELLOW,
                },
              ],
            }}
          />
        )}
      </LoadableState>
    )}
  </FilteredRequest>
));

export default SatisfactionChart;
